// media.js — Résout une URL d'image stockée (relative /api/... ou absolue/externe).
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export function mediaUrl(url) {
  if (!url) return '';
  if (url.startsWith('http://') || url.startsWith('https://') || url.startsWith('data:')) return url;
  if (url.startsWith('/api/')) return `${BACKEND_URL}${url}`;
  return url;
}

// Télécharge un fichier protégé (avec le JWT) et déclenche l'enregistrement navigateur.
export async function downloadAuthed(apiPath, filename) {
  const token = localStorage.getItem('assoperf_token');
  const res = await fetch(`${BACKEND_URL}${apiPath}`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  if (!res.ok) throw new Error('Téléchargement impossible');
  const blob = await res.blob();
  const href = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = href;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(href);
}
